import { AwardsStorageService } from "src/application/ports";
import { useStore } from "./store";

export function useAwardsStorage(): AwardsStorageService {
  return useStore();
}
